import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import Field from 'components/Field'

export default function Fields({ children, className }: props) {
  const body = React.Children.map(children, (child, index) => (
    <div key={index} className="uk-width-1-2">
      {child}
    </div>
  ))

  return (
    <Field className={classNames('Fields', className)}>
      <div uk-grid="true" className="uk-grid">
        {body}
      </div>
    </Field>
  )
}

Fields.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Fields/Fields.js